import { createContext, useContext, useState, useCallback, useMemo } from 'react';

const PageHeaderContext = createContext({
  header: null,
  setHeader: () => {},
  clearHeader: () => {},
});

export const PageHeaderProvider = ({ children }) => {
  const [header, setHeader] = useState(null);

  const clearHeader = useCallback(() => {
    setHeader(null);
  }, []);

  const contextValue = useMemo(() => ({
    header,
    setHeader,
    clearHeader,
  }), [header, setHeader, clearHeader]);

  return (
    <PageHeaderContext.Provider value={contextValue}>
      {children}
    </PageHeaderContext.Provider>
  );
};

export const usePageHeader = () => {
  const context = useContext(PageHeaderContext);
  if (!context) {
    throw new Error('usePageHeader must be used within PageHeaderProvider');
  }
  return context;
};
